import common from "./common";
import app from "./app";
import settings from "./settings";
import userSettings from "./userSettings";
import settingsPages from "./settingsPages";
import cart from "./cart";
import catalogue from "./catalogue";
import articleTile from "./articleTile";
import checkout from "./checkout";
import dialogs from "./dialogs";
import orderHistory from "./orderHistory";
import store from "./store";
import dtoLabels from "./dtoLabels";
// The series request is not translated yet. Pointing at the german texts shows exactly what
// the fallback would show anyway, but without a vue-i18n warning per key: every one of those
// warnings is posted to the client log (see log.js), which runs into its rate limit.
import offerRequest from "../de-CH/offerRequest";

export default {
	common,
	app,
	settings,
	userSettings,
	settingsPages,
	cart,
	catalogue,
	articleTile,
	checkout,
	dialogs,
	orderHistory,
	store,
	dtoLabels,
	offerRequest,
};
